import temp from "./temp";
import user from "./user";

export default {
  flatmap: {},
  mapRefs: {},
  ...user,
  ...temp,
}
